import type { InstallationWithRelations } from './service'

const SHAYP_APP_URL = 'https://app.shayp.io'
const EFENTO_APP_URL = 'https://cloud.efento.io'
// Trailing segment of an Efento sensor URL. Constant across our devices; not the
// measurement point, and unrelated to EFENTO_LOCATION_ID as far as we know.
const EFENTO_SENSOR_URL_SUFFIX = '14736'

type InstallationDataSource = NonNullable<InstallationWithRelations['water_station']>['data_sources'][number]

export interface ProviderDeviceLink {
  provider: 'shayp' | 'efento'
  label: string
  deviceId: string
  url: string
}

const shaypDeviceLink = (
  dataSource: InstallationDataSource,
  shaypAccountId: string | null
): ProviderDeviceLink | null => {
  if (!shaypAccountId || !dataSource.provider_device_id) return null
  return {
    provider: 'shayp',
    label: 'Shayp',
    deviceId: dataSource.provider_device_id,
    url: `${SHAYP_APP_URL}/accounts/${shaypAccountId}/devices/${dataSource.provider_device_id}/`
  }
}

// Efento devices are only addressable once sync-efento has bound a measurement point.
const efentoDeviceLink = (dataSource: InstallationDataSource): ProviderDeviceLink | null => {
  if (dataSource.measurement_point_id === null) return null
  return {
    provider: 'efento',
    label: 'Efento',
    deviceId: String(dataSource.measurement_point_id),
    url: `${EFENTO_APP_URL}/sensor/${dataSource.measurement_point_id}/${EFENTO_SENSOR_URL_SUFFIX}`
  }
}

export const buildProviderDeviceLink = ({
  dataSources,
  shaypAccountId
}: {
  dataSources: InstallationDataSource[]
  shaypAccountId: string | null
}): ProviderDeviceLink | null => {
  const meter = dataSources.find((source) => source.source_type === 'meter')
  if (!meter) return null
  if (meter.maker === 'shayp') return shaypDeviceLink(meter, shaypAccountId)
  if (meter.maker === 'efento') return efentoDeviceLink(meter)
  return null
}
